import L from 'leaflet';
import 'leaflet.markercluster';
import 'leaflet-lasso';
import './L.Control.MousePosition';

import debounce from 'lodash.debounce';

import './drop-down';
import { asExcel } from './xlsx';
import { $, $div, $icon, $json, $br, $a } from './lib.js';
import { SampleCart } from './sample-cart';

import "../node_modules/leaflet/dist/leaflet.css";
import "../node_modules/leaflet.markercluster/dist/MarkerCluster.css"
import "../node_modules/leaflet.markercluster/dist/MarkerCluster.Default.css"
import "./global.css"
import "./site.css"

import * as unmess from './unmess'

import { FrontEndVersion, BackEndVersion, DatabaseVersion, BuildDate } from './version'

//import "./font-awesome-4.7.0/css/font-awesome.css"

//import './fa.js';

const MAX_SHOWN = 100;

import { polygonIsSimple, pointsToFeature, polygonSplit } from "./geometry";

import { Sample } from './sample';

import { SampleView } from './sample-view';
import { SampleDetails } from './sample-details';

const minZoom = 1;
const maxZoom = 15;
const center = L.latLng([42, -71]);
const zoomControl = false;
const zoom = 3;

const cart = new SampleCart();
$('#cart').add(cart);

const HIGHLIGHT_COLOR = 'fuchsia';

const osm = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxNativeZoom: 13,
    maxZoom: maxZoom,
    attribution: '© OpenStreetMap',
    opacity: 1.0,
});
const osm2 = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxNativeZoom: 13,
    maxZoom: maxZoom,
    attribution: '© OpenStreetMap',
    opacity: 1.0,
});

const wmsOptions_2 = {
    layers: 'GMRT',
    format: 'image/png',
    transparent: true,
    tileSize: 256,
    opacity: 0.85,
}
var gmrt_basemap_2 = L.tileLayer.wms(
    'https://www.gmrt.org/services/mapserver/wms_merc?request=GetCapabilities&service=WMS',
    wmsOptions_2
)
const wmsOptions_3 = {
    layers: 'GMRT',
    format: 'image/png',
    transparent: true,
    tileSize: 256,
}
var gmrt_basemap_3 = L.tileLayer.wms(
    'https://www.gmrt.org/services/mapserver/wms_merc?request=GetCapabilities&service=WMS',
    wmsOptions_3
)


const esri_topo = L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png', {
    opacity: 0.6,
    attribution: '<a href="https://www.arcgis.com/home/item.html?id=10df2279f9684e4a9f6a7f08febac2a9">ESRI World Imagery</a>',
    //minZoom,
    //maxNativeZoom: 8,
    //maxZoom: 13
})
const esri_topo_1 = L.tileLayer('https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png', {
    opacity: 1.0,
    attribution: '<a href="https://www.arcgis.com/home/item.html?id=10df2279f9684e4a9f6a7f08febac2a9">ESRI World Imagery</a>',
    //minZoom,
    //maxNativeZoom: 8,
    //maxZoom: 13
})

const osm_gmrt = L.layerGroup([osm, gmrt_basemap_2])
const osm_esri = L.layerGroup([osm2, esri_topo])


const layers = [osm_gmrt];

const map = L.map('map', {
    minZoom,
    maxZoom,
    zoomControl,
    center,
    zoom,
    layers,
})

L.control.layers({
    'GMRT/OSM': osm_gmrt,
    'Topo/OSM': osm_esri,
    'GMRT': gmrt_basemap_3,
    'Topo': esri_topo_1
}).addTo(map);

L.control.zoom({ position: 'topright' }).addTo(map);

L.control.lasso({}).addTo(map);

function capitalize(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
function key_fmt(x: string) {
    return x.replaceAll('_', ' ').split(/\s+/).map(capitalize).join(" ")
}

function full_sample(sample: Sample) {

    return new SampleDetails(sample, cart.has(sample));
    /*
      const s = sample;
      const div = $div({ style: "position: relative;" });
      const keys = ['Full_Sample_Name', 'Object_Type',
        'lat', 'lon', 'depth',
        'Sample_Description',
        'Collection_Date',
      ];
      const skips = ['Drawer_Location', 'sample_id', 'IGSN', 'MardsenSq'];
      div.add($div(
        s.Full_Sample_Name,
        { style: "font-size: 1.2em; font-weight: bold;" }
      ));
      div.add($div(s.Object_Type));
      div.add($div($icon('location-arrow'),
        ` ${s.lat.toFixed(3)}, ${s.lon.toFixed(3)}`));
      if (Number.isFinite(s.depth))
        div.add($icon('angle-down'), ` ${s.depth} m`);
      div.add($div($icon('calendar'), ' ', s.Collection_Date));
      if (s.Sample_Description && s.Sample_Description != "") {
        div.add($div($icon('commenting-o', {
          style: "display: inline"
        }), " ", s.Sample_Description, {
          style: "margin-left: 3em; text-indent: -3em;"
        }))
      }
    
      const sample_any: { [key: string]: any } = sample;
    
      div.add($div("", { style: "height: 1em" }));
      for (const key of Object.keys(sample_any).sort()) {
        if (keys.includes(key) || skips.includes(key) || key.startsWith('IMLGS_') || key.startsWith('SESAR_')) {
          continue
        }
        if (!sample_any[key]) {
          continue;
        }
        div.add($div($div(key_fmt(key), { class: 'bold', style: 'display: inline' }), `: ${sample_any[key]}`,
          { style: "margin-left: 3em; text-indent: -3em;" }
        ));
      }
      if ('IGSN' in sample && sample.IGSN) {
        div.add($div(sample.IGSN));
      }
      if (!cart.has(sample)) {
        div.add($div($icon("plus"), {
          class: "result-item-add full-result-item-add",
          title: "Add to Cart",
          click: (_ev: Event) => {
            cart_add_sample(sample);
          }
        }));
      } else {
        div.add(result_item_remove_button(sample, true));
      }
      return div;
    */
}


function cart_size_update() {
    const n = cart.size()
    const el = $('#cart_size')
    if (n == 0) {
        el.style.display = 'none'
    } else {
        el.style.display = 'block'
    }
    el.textContent = n
}
cart_size_update()
cart.addEventListener('cart-item-add', (ev) => {
    cart_size_update()
})
cart.addEventListener('cart-item-remove', (ev) => {
    cart_size_update()
})


function cart_add_sample(sample: Sample) {
    if (cart.has(sample)) {
        return;
    }
    cart.add(sample);
    redraw_search();
}

function sample_to_id(sample: Sample) {
    return sid(sample.Full_Sample_Name);
}
function sid(name: string) {
    return 'id' + name.replaceAll(' ', '_');
}

function cart_action(sample: Sample) {
    if (cart.has(sample)) {
        cart.rm(sample);
    } else {
        cart.add(sample);
    }
}
$('#cart').addEventListener('cart-item-add', (ev: CustomEvent) => {
    const sample = ev.detail;
    const is_sample = (kid: any) => { return kid.name() == sample.Full_Sample_Name; }
    const r = $('#results_list');
    [...r.children].filter(is_sample).forEach(kid => kid.in_cart = true);
    const f = $('#full_results_list');
    [...f.children].filter(is_sample).forEach(kid => kid.in_cart = true);

})

$('#cart').addEventListener('cart-item-remove', (ev: CustomEvent) => {
    const sample = ev.detail;
    const is_sample = (kid: any) => { return kid.name() == sample.Full_Sample_Name; }
    const r = $('#results_list');
    [...r.children].filter(is_sample).forEach(kid => kid.in_cart = false);
    const f = $('#full_results_list');
    [...f.children].filter(is_sample).forEach(kid => kid.in_cart = false);
})

$('#full_results').addEventListener('cart-action', (ev: CustomEvent) => {
    const sample = ev.detail;
    cart_action(sample);
});
$('#results').addEventListener('cart-action', (ev: CustomEvent) => {
    const sample = ev.detail;
    cart_action(sample);
})

$('#results').addEventListener('sample-detail', (ev: CustomEvent) => {
    const sample = ev.detail;
    click_sample(sample);
});
$('#full_results').addEventListener('sample-detail', (ev: CustomEvent) => {
    const sample = ev.detail;
    click_sample(sample);
});

async function click_sample(sample: Sample) {
    const s = sample;
    const full = $('#full_results_list');
    let sample_full
    if (sample.sub_sample_id) {
        sample_full = await $json(`subsamples/${s.sub_sample_id}`);
        sample_full.subsamples = []
    } else {
        sample_full = await $json(`samples/${s.sample_id}`);
        if (sample_full === undefined) {
            return;
        }
        sample_full.subsamples = []
        if (s.IGSN) {
            const subsamples = await $json(`subsamples/parent/${s.IGSN}`)
            sample_full.subsamples = subsamples || []
        }
    }
    full.clear();
    full.add(full_sample(sample_full));
    show_full_results();
    open_sidebar();
    normal_map_marker(sample);
}

// Small / Brief Description of the Sample
function result_item(sample: Sample) {

    return new SampleView(sample, cart.has(sample))
    /*
    
      const s = sample;
      const classes = ["sample"];
      if (cart.has(sample)) {
        classes.push("incart");
      }
      const item = $div(
        $div(`${s.Full_Sample_Name}`, { style: "font-weight: bold; font-size: 1.1em;" }),
        $div(s.Object_Type),
        $div($icon('location-arrow'), ` ${s.lat.toFixed(3)}, ${s.lon.toFixed(3)}`),
        (s.depth !== undefined) ? $div($icon('angle-down'), ` ${s.depth} m`) : "",
        {
          class: classes,
          id: sample_to_id(sample),
          click: (_ev: Event) => click_sample(s),
          mouseover: (_ev: Event) => {
            highlight_map_marker(sample, true);
          },
          mouseout: (_ev: Event) => {
            highlight_map_marker(sample, false);
          }
        }
      );
      if (!cart.has(sample)) {
        const add = $div($icon('plus'), {
          class: 'result-item-add',
          title: 'Add to Cart',
          click: (ev: Event) => {
            ev.stopPropagation();
            cart_add_sample(s);
            //    $(`#${sample_to_id(s)}`).classList.add('incart');
            //    cart.add(s.Full_Sample_Name);
            //}
    
            return false;
          }
        });
        item.add(add);
      } else {
        const remove = result_item_remove_button(sample);
        item.add(remove);
      }
      return item;
    */
}

function result_item_remove_button(sample: Sample, full: boolean = false) {
    const s = sample;
    let classList = 'result-item-remove';
    if (full)
        classList += " full-result-item-remove";
    const remove = $div($icon('minus'), {
        class: classList,
        title: "Remove from cart",
        id: sample_to_id(s) + '_remove',
        click: (ev: Event) => {
            ev.stopPropagation();
            if (cart.has(sample)) {
                cart.remove(sample);
            }
            return false;
        }
    });
    return remove;
}

let current_map_marker: L.Marker | undefined = undefined;
function current_map_marker_clear() {
    if (current_map_marker) {
        current_map_marker.remove();
        current_map_marker = undefined;
    }
}

function argmin(values: number[]) {
    if (values.length == 0) {
        return -1
    }
    let k = 0
    for (let i = 1; i < values.length; i++) {
        if (values[i] < values[k]) {
            k = i
        }
    }
    return k
}

function normal_map_marker(sample: Sample) {
    const minZoomSample = 5
    const marker = L.marker([sample.lat, sample.lon]);
    current_map_marker = marker;
    marker.addTo(map);
    const bounds = map.getBounds()
    // Find closest marker accounting for 0/360 longitude
    const center = map.getCenter()
    let lons = [sample.lon, sample.lon - 360, sample.lon + 360]
    let lon = lons[argmin(lons.map(lon => Math.abs(lon - center.lng)))]
    const pos = L.latLng([sample.lat, lon])
    if (bounds.contains(pos)) {
        map.flyTo(pos, Math.max(map.getZoom(), minZoomSample))
        return
    }
    map.flyTo(pos, minZoomSample);
}

function highlight_map_marker(sample: Sample, show: boolean) {
    if (!sample)
        return;
    const s = sample;
    const markers = map_markers[s.Full_Sample_Name];
    if (!markers) {
        return;
    }
    let opts = {
        radius: 10,
        color: 'rgba(255,0,255,0.9)',
        fillColor: 'rgba(255,0,255,0.6)',
        highlight: true
    };

    if (show) {
        markers.filter(x => x).forEach((m: any) => m.refreshIconOptions(opts, true));
    } else {
        markers.filter(x => x).forEach((m: any) => m.refreshIconOptions(m.options.state, true));
    }
}


let xlasso: any = undefined;

function set_lasso_enabled(enabled: boolean) {
    let lasso_ele = [...document.getElementsByClassName("leaflet-control-lasso")]
    if (enabled) {
        lasso_ele.forEach(el => L.DomUtil.addClass(el, "enabled"))
    } else {
        lasso_ele.forEach(el => L.DomUtil.removeClass(el, "enabled"))
    }
}

map.on('lasso.enabled', () => {
    if (xlasso)
        xlasso.remove();
    LPolys.forEach(p => p.remove());
    set_lasso_enabled(true)
    //lassoEnabled.innerHTML = 'Enabled';
    clear_selected();
    clear_search_result();
});

map.on('lasso.enabled', (event) => {
    set_lasso_enabled(true)
});

let LPolys: any = [];

map.on('lasso.finished', async (event) => {
    clear_search_result();

    set_lasso_enabled(false)
    // @ts-ignore
    const ll: L.LatLng[] = event.latLngs;

    xlasso = L.polygon([...ll]).addTo(map);

    // Remove repeated points
    const pts = [];
    for (const pt of ll) {
        const p = [pt.lng, pt.lat];
        if (!pts.length)
            pts.push(p)
        else {
            const last = pts[pts.length - 1];
            if (last[0] != p[0] || last[1] != p[1])
                pts.push(p);
        }
    }

    let poly = pointsToFeature(pts);

    const simple = polygonIsSimple(poly);
    if (!simple) {
        let polygons = unmess.unmess(poly.geometry.coordinates[0], {
            hole_policy: unmess.HOLE_NONE, // or HOLE_NONE, HOLE_EVENODD, HOLE_AGGRESSIVE
            epsilon: 0.0001,
        });
        poly.geometry.coordinates = polygons
    }

    let split = polygonSplit(poly, [[-180, -90], [-180, 90]]);
    if (!split) {
        console.error('error spliting polygon')
        return;
    }
    const polys = [];
    for (const poly of split) {
        const pts = [];
        if (poly.every((pt: any) => pt[0] <= -180)) {
            for (const p of poly) {
                let y = p[1]
                let x = p[0];
                if (x <= -180) {
                    x += 360;
                }
                pts.push([x, y])
            }
            polys.push(pointsToFeature(pts))
        }
        polys.push(pointsToFeature(poly))
    }

    LPolys = polys.map((poly: any) => L.geoJSON(poly, {
        style: (_feat) => {
            return { color: 'red' }
        }
    }).addTo(map));

    const res = await fetch('/samples/poly/', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(polys),
    });
    if (!res.ok) {
        console.error(res.statusText);
        return;
    }
    const samples = await res.json();
    show_search_result(samples);
});

function clear_selected() {
    map.eachLayer(layer => {
        if (layer instanceof L.Marker && !(layer instanceof L.MarkerCluster)) {
            layer.setIcon(new L.Icon.Default());
        } else if (layer instanceof L.Path) {
            layer.setStyle({
                color: '#333',
                fillColor: layer.options.baseColor,
            });
        }
    });
    $('#results_list').clear();
}


L.control.mousePosition({
    lngFirst: true,
    position: 'bottomright',
    latFormatter: (x => (x).toFixed(3)),
    lngFormatter: (x => (x).toFixed(3)),
}).addTo(map);

// Catch "Almost" clicks for people with fat fingers on touch screens
//   The fingers you have used to dial are too fat ...
//   https://www.youtube.com/watch?v=OqjF7HKSaaI
map.on('almost:click', function(ev) {
    var layer = ev.layer;
    if (layer.openPopup) {
        layer.fire('click', ev);
    }
});


map.on('click', function(_ev) { current_map_marker_clear(); });

const map_markers: { [key: string]: L.CircleMarker[] } = [];
//let myRepeatingMarkers = L.gridLayer.repeatedMarkers().addTo(map);

let clusterTooltip: L.Tooltip;

const map_group = L.markerClusterGroup({
    spiderfyOnMaxZoom: true,
    showCoverageOnHover: false,
    zoomToBoundsOnClick: false,
    maxClusterRadius: 15,
    disableClusteringAtZoom: 12,
    iconCreateFunction: function(cluster) {
        var childCount = cluster.getChildCount();

        var c = ' marker-cluster-';
        if (childCount < 10) {
            c += 'small';
        } else if (childCount < 100) {
            c += 'medium';
        } else {
            c += 'large';
        }
        let point = new L.Point(20, 20);
        // @ts-ignore
        if (cluster._group._highlight) {
            c = 'marker-cluster-highlight';
            point = new L.Point(28, 28);
        }
        return new L.DivIcon({
            html: `<div><span>${childCount}</span></div>`,
            className: `marker-cluster ${c}`,
            iconSize: point,
        });
    }
});
L.CircleMarker.include({
    refreshIconOptions: function(options: any, directlyRefreshClusters: any) {
        this.setStyle(options);
        this.bringToFront();
        if (directlyRefreshClusters && this.__parent) {
            this.__parent._group._highlight = ('highlight' in options) ? options.highlight : false;
            this.__parent._group.refreshClusters([this]);
        }
        return this;
    },
});

map_group.on('clustermouseover', (cluster) => {
    let tips = [];
    for (const item of cluster.layer.getAllChildMarkers()) {
        tips.push(item._tooltip._content);
    }
    const txt = tips.join("<br/>");
    clusterTooltip = L.tooltip().setLatLng(cluster.layer._latlng).setContent(txt).addTo(map);
});

map_group.on('clustermouseout', (_cluster) => {
    clusterTooltip.remove();
});

function show_search_result(samples: Sample[]) {
    const results = $('#results_list');
    const n = samples.length;
    const link = $a("csv", "#", () => {
        download(json_to_csv(samples), "mgsl_samples.csv", "text/csv")
    })
    const link_xls = $a("excel", "#", async () => {
        const buffer = await json_to_excel(samples)
        download(buffer, "mgsl_samples.xlsx",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
    })
    link.title = "Get items as CSV"
    link_xls.title = "Get items as Excel"
    if (n > MAX_SHOWN) {
        $('#info').set(
            $div(`List below contains only ${MAX_SHOWN} / ${n} samples`),
            $div("Add terms to limit search"),
            $div("Get items as ", link, " ", link_xls),
        );
    } else {
        const word = (n == 1) ? "sample" : "samples";
        if (n == 0) {
            $('#info').set($div(`${n} ${word} found`))
        } else if (n > 0) {
            $('#info').set(
                $div(`${n} ${word} found `),
                $div("Get items as ", link, " ", link_xls)
            );
        }
    }
    for (const s of samples) {
        const markers = sample_marker(s);
        markers.forEach(marker => map_group.addLayer(marker));
        map_markers[s.Full_Sample_Name] = markers;
    }
    for (const s of samples.slice(0, MAX_SHOWN)) {
        results.add(result_item(s));
    }
    show_results();

    if (n == 0) {
        $('#no_results').style.display = 'block'
    }

    map_group.addTo(map);
}

function clear_search_result() {
    // Clear current search list
    const results = $('#results_list');
    $('#info').clear();
    results.clear();
    map_group.clearLayers();
    for (const markers of Object.values(map_markers)) {
        markers.forEach(m => m.remove());
    }
    if (xlasso)
        xlasso.remove();
    LPolys.forEach(p => p.remove());
}

async function update_search(input: string) {
    clear_search_result();
    if (input.length == 0) {
        show_no_results()
        window.history.replaceState({}, null, "?q=")
        return;
    }
    const samples = await $json(`query?q=${input}`);
    // Populdate search list
    show_search_result(samples);
    window.history.replaceState({}, null, `?q=${input}`)
}

function search_request(ev: Event) {
    const el = ev.target as HTMLInputElement;
    const input = el.value.trim();
    update_search(input);
}

const search_debounce = debounce(search_request, 200, { leading: false })
$('#search').addEventListener('input', search_debounce);


//$('#sidebar').style.display = 'none';
update_search($('#search').value.trim());

function sample_marker(sample: Sample) {
    const lat = sample.lat;
    const lng = sample.lon;
    const markers = [];
    for (let offset = -360; offset <= 360; offset += 360) {
        var marker = L.circleMarker([lat, lng + offset], {
            // @ts-ignore
            title: sample.Full_Sample_Name,
            radius: 6,
            color: 'rgba(255,0,0,0.9)',//BASE_COLOR[sample.Object_Type] || BASE_COLOR.Unknown,
            weight: 1.5,
            fill: true,
            fillOpacity: 0.9,
            //fillColor: BASE_COLOR[sample.Object_Type] || BASE_COLOR.Unknown,
            //baseColor: BASE_COLOR[sample.Object_Type] || BASE_COLOR.Unknown,
            fillColor: 'rgba(255,0,0,0.5)',
            baseColor: 'rgba(255,0,0,0.5)',
            name: sample.Full_Sample_Name,
            data: sample,
        });
        marker.on('click', (_ev: any) => {
            click_sample(sample);
        });
        marker.bindTooltip(sample.Full_Sample_Name, { className: 'ztooltip', });
        // @ts-ignore
        marker.options.state = {
            color: marker.options.color,
            fillColor: marker.options.fillColor,
            highlight: false,
            radius: marker.options.radius,
        };
        markers.push(marker);
    }

    return markers;
}

function quote(value: any) {
    if (value === null || value === undefined) {
        return ""
    }
    value = value.toString()
    if (value.includes(","))
        return `"${value}"`
    return value
}

const FIELDS = [
    'sample_id', 'sub_sample_id', 'Full_Sample_Name', 'Object_Type',
    'lat', 'lon', 'depth', 'IGSN', 'Parent_IGSN',
    'Collection', 'Material',
    'Sample_Description',
]
async function json_to_excel(rows: any) {
    return asExcel(rows, FIELDS)
}

function json_to_csv(rows: any) {
    if (rows.length == 0)
        return ""
    const lines = []
    lines.push('#' + FIELDS.map(quote).join(","))
    lines.push(...rows.map((row: any) => {
        return FIELDS.map(key => row[key] || "").map(quote).join(",")
    }))
    return lines.join("\n")
}

function download(data, filename, type = "application/json") {
    const blob = new Blob([data], { type })
    const a = document.createElement('a')
    a.href = URL.createObjectURL(blob)
    a.download = filename
    a.click()
}

function close_sidebar() {
    $('#sidebar').style.display = 'none';
}
function open_sidebar() {
    $('#sidebar').style.display = 'block';
}
function close_cart() {
    $('#sidebar_cart').style.display = 'none';
}
function open_cart() {
    $('#sidebar_cart').style.display = 'block';
}
function close_doc() {
    $('#sidebar_doc').style.display = 'none';
}
function open_doc() {
    $('#sidebar_doc').style.display = 'block';
}
function close_about() {
    $('#sidebar_about').style.display = 'none';
}
function open_about() {
    $('#sidebar_about').style.display = 'block';
}
function show_full_results() {
    $('#full_results').style.display = 'block';
    $('#no_results').style.display = 'none';
    $('#info').style.display = 'none';
    $('#results').style.display = 'none';
    $('#help').style.display = 'none';
}

function show_results() {
    $('#results').style.display = 'block';
    $('#full_results').style.display = 'none';
    $('#no_results').style.display = 'none';
    $('#info').style.display = 'flex';
    $('#help').style.display = 'none';
}

function show_no_results() {
    $('#results').style.display = 'none';
    $('#full_results').style.display = 'none';
    $('#no_results').style.display = 'block';
    $('#info').style.display = 'flex';
    $('#help').style.display = 'none';
}

function search_toggle() {
    const side = $('#sidebar');
    if (side.style.display == 'block') {
        side.style.display = 'none';
    } else {
        side.style.display = 'block';
    }
}

const SIDEBAR_CLOSE = 0
const SIDEBAR_SEARCH = 1
const SIDEBAR_CART = 2
const SIDEBAR_DOC = 3
const SIDEBAR_ABOUT = 4
let sidebar_state = SIDEBAR_SEARCH

function open_bar(state: number) {
    switch (state) {
        case SIDEBAR_SEARCH: open_sidebar(); break;
        case SIDEBAR_CART: open_cart(); break;
        case SIDEBAR_DOC: open_doc(); break;
        case SIDEBAR_ABOUT: open_about(); break;
    }
}
function close_bar(state: number) {
    switch (state) {
        case SIDEBAR_SEARCH: close_sidebar(); break;
        case SIDEBAR_CART: close_cart(); break;
        case SIDEBAR_DOC: close_doc(); break;
        case SIDEBAR_ABOUT: close_about(); break;
    }
}

function sidebar_action(new_state) {
    if (new_state == sidebar_state) {
        close_bar(new_state)
        sidebar_state = SIDEBAR_CLOSE
    } else if (sidebar_state == SIDEBAR_CLOSE) {
        open_bar(new_state)
        sidebar_state = new_state
    } else {
        close_bar(sidebar_state)
        open_bar(new_state)
        sidebar_state = new_state
    }
}

$('#search_button').addEventListener('click', (_ev: Event) => {
    sidebar_action(SIDEBAR_SEARCH)
})
$('#cart_button').addEventListener('click', (_ev: Event) => {
    sidebar_action(SIDEBAR_CART)
})
$('#doc_button').addEventListener('click', (_ev: Event) => {
    sidebar_action(SIDEBAR_DOC)
})
$('#about_button').addEventListener('click', (_ev: Event) => {
    sidebar_action(SIDEBAR_ABOUT)
})

$('#sidebar_open').addEventListener('click', (_ev: Event) => {
    //search_toggle();
});

$('#full_results_back_button').addEventListener('click', (_ev: Event) => {
    show_results();
    current_map_marker_clear();
});

$('#settings_button').addEventListener('mouseover', (_ev: Event) => {
    $('#settings').style.display = 'block';
});

$('#settings_button').addEventListener('mouseout', (_ev: Event) => {
    $('#settings').style.display = 'none';
});

$('#settings').addEventListener('mouseover', (_ev: Event) => {
    $('#settings').style.display = 'block';
});

$('#settings').addEventListener('mouseout', (_ev: Event) => {
    $('#settings').style.display = 'none';
});


$('#help_button').addEventListener('click', (_ev: Event) => {
    $('#results').style.display = 'none';
    $('#full_results').style.display = 'none';
    $('#no_results').style.display = 'none';
    $('#help').style.display = 'block';
    $('#info').style.display = 'none';
})

$('#help_button_close').addEventListener('click', (_ev: Event) => {
    show_results()
})

function add_menu_items(menu: any, items: string[]) {
    items.sort().forEach(name => {
        const v = document.createElement('search-term');
        let term = name;
        if (term.includes(' '))
            term = `"${term}"`
        v.setAttribute('term', term);
        v.textContent = name
        menu.add(v);
    });
}


const vessels = [
    "Nautilus",
    "Trident",
    "Yokosuka",
    "Southern Surveyor",
    "Atlantis II",
    "Moana Wave",
    "Neil Armstrong",
    "Ronald H. Brown",
    "Knorr",
    "Bjarni Saemundsson",
    "Aegaeo",
    "Pelican",
    "Gyre",
    "Roger Revelle",
    "Wecoma",
    "Endeavor",
    "Billie",
    "Thomas G. Thompson",
    "Melville",
    "Nathanial B. Palmer",
    "Akademik Boris Petrov",
    "Seward Johnson",
    "Natsushima",
    "Alliance",
    "Robert D. Conrad",
    "Yaquina",
    "Thomas Washington",
    "Vema",
    "Hakurei-maru",
    "Gilliss",
];
const objects = [
    //"Grab", "Core", "Dredge", "Core Whole Round", "Core Section Half", "Core Half Round", "Other"
    "Individual Sample", "Grab", "Dredge", "Core", "Core Section", "Other"
];


const provinces = [
    //"Seamount", "Island Arc", "Subduction zone", "Ridge", "Fracture Zone", "Continental Shelf"",
    "abyssal feature",
    "alluvial fan",
    "anticline",
    "aquifer",
    "arch (natural formation)",
    "arroyo",
    "atoll",
    "badlands",
    "bank (hydrographic)",
    "bar (physiographic)",
    "basin",
    "bay",
    "beach",
    "bight",
    "caldera",
    "canyon",
    "cape",
    "cave",
    "channel",
    "cirque",
    "cliff",
    "continental divide",
    "continental margin",
    "continental shelf",
    "crater",
    "delta",
    "drainage basin",
    "drumlin",
    "dune",
    "earthquake feature",
    "estuary",
    "fault",
    "fault zone",
    "flat",
    "floodplain",
    "fold (geologic)",
    "forearc",
    "fracture zone",
    "gap",
    "gulf",
    "gut",
    "hydrothermal vent",
    "ice mass",
    "isthmus",
    "karst area",
    "lagoon",
    "lake",
    "lava field",
    "ledge",
    "massif",
    "mesa",
    "mid-ocean ridge",
    "mineral deposit area",
    "moraine",
    "mountain",
    "mountain range",
    "mountain summit",
    "ocean trench",
    "outcrop",
    "plain",
    "plateau",
    "playa",
    "reef",
    "ridge",
    "rift zone",
    "roadcut",
    "sea",
    "seamount",
    "spreading center",
    "stream",
    "submarine canyon",
    "syncline",
    "thermal feature",
    "trench",
    "valley",
    "volcano"
];

async function menu_items() {
    const res = await fetch("/cruises")
    const cruises = await res.json()
    const vessels = [...new Set(cruises.map((c: any) => c.Platform_Name))].filter(v => v) as string[]
    add_menu_items($('#vessels'), vessels);
    add_menu_items($('#objects'), objects);
    add_menu_items($('#province'), provinces);

}
menu_items()

const params = new URLSearchParams(window.location.search)

if (params.has("q")) {
    let query = params.get('q')
    if (query) {
        $('#search').value = query
        update_search(query)
    }
}
async function show_full_sample_by_name_value(column: string, name: string) {
    const samples = await $json(`/query?q=${column}: ${name}`)
    if (samples.length != 1) {
        return
    }
    const sample = samples[0]
    click_sample(sample)
}

function is_quoted(s: string) {
    if (s.length > 1)
        return false
    if (s[0] == '"') {
        return s.at(-1) == '"'
    }
    return false
}

function quote_string(s: string) {
    if (is_quoted(s)) {
        return s
    }
    return `"${s}"`
}

if (params.has("name")) {
    let name = quote_string(params.get('name') || "")
    if (name) {
        $('#search').value = `Full_Sample_Name: ${name}`
        update_search($('#search').value.trim())
        show_full_sample_by_name_value("Full_Sample_Name", name)
    }
} else if (params.has("igsn")) {
    let name = quote_string(params.get('igsn') || "")
    if (name) {
        $('#search').value = `IGSN: ${name}`
        update_search($('#search').value.trim())
        show_full_sample_by_name_value("IGSN", name)
    }
}


async function word_cloud() {
    const res = await fetch("words.json")
    let list = await res.json()
    const size = list[0][1]
    list = list.map((v: any) => [v[0], v[1] / size])
    const weightFactor = 70
    const gridSize = 8
    const wc = $('#wordcloud')
    const rect = wc.getBoundingClientRect()
    const ngx = Math.ceil(rect.width / gridSize)
    const ngy = Math.ceil(rect.height / gridSize)
    const maxRadius = Math.floor(Math.sqrt(ngx * ngx + ngy * ngy)) / 2

    let el: any = null
    WordCloud(wc, {
        list,
        weightFactor: (size) => {
            return 4 + size * (weightFactor - 10)
        },
        minSize: 6,
        backgroundColor: '#00000020',
        //shrinkToFit: true,
        color: (_word: any, _weight: number, _fontSize: number, distance: number, theta: number) => {
            // Color wheel RGB around, brighter in the middle
            const h = theta / (2 * Math.PI) * 360
            const l = 50 * (1 - (distance / maxRadius)) + 50
            return `hsl(${h},100%,${l}%)`
        },
        click: (item: any, _dimension: any, _event: any) => {
            $('#search').value = item[0]
            update_search(item[0])
            //const url = `https://rigs.uri.edu/?q=${item[0]}`
            //window.open(url, "_blank").focus()
        },
        hover: (item: any, _dimension: any, event: any) => {
            // Color
            if (el) {
                el.style.filter = "brightness(100%)"
            }
            if (event.target && item && event.target.id != "wordcloud") {
                el = event.target
                el.style.filter = "brightness(200%)"
                el.title = `${item[0]}: ${Math.round(item[1] * size)}`
            }
        },
    })
}

$('#wordcloud_link').addEventListener('click', (ev) => { word_cloud() })

$('#version').innerHTML = `
<div>Build Date: ${BuildDate}</div>
<div>Front End Version: ${FrontEndVersion} (map)</div>
<div>Back End Version: ${BackEndVersion} (server)</div>
<div>Database Version: ${DatabaseVersion} (db-editor)</div>
`
